/* Divine Importers refresh: desktop mega menu (October 2026). No dependencies.
   Hover (or tap) Food, Wine or Beverages to open its panel; Down arrow or Space opens it from the keyboard; Escape closes. */
(function () {
  function init() {
    var wrap = document.querySelector('[data-mm-wrap]'); if (!wrap || wrap.__mm) return; wrap.__mm = true;
    var scrim = wrap.querySelector('[data-mm-scrim]');
    var desk = window.matchMedia('(min-width: 761px)');
    var current = null, openT = null, closeT = null;

    function panelFor(a) { return document.getElementById(a.getAttribute('data-mm')); }
    function sizeScrim() {
      if (!scrim) return;
      var top = wrap.getBoundingClientRect().bottom + window.pageYOffset;
      var full = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
      scrim.style.height = Math.max(0, full - top) + 'px';
    }
    function hide(a) {
      var p = panelFor(a); if (p) p.hidden = true;
      a.setAttribute('aria-expanded', 'false'); a.classList.remove('mm-open');
    }
    function open(a) {
      clearTimeout(openT); clearTimeout(closeT);
      if (current === a) return;
      var p = panelFor(a); if (!p) return;
      if (current) hide(current);
      p.hidden = false; a.setAttribute('aria-expanded', 'true'); a.classList.add('mm-open');
      current = a; sizeScrim(); wrap.classList.add('mm-on');
    }
    function close() {
      clearTimeout(openT); clearTimeout(closeT);
      if (!current) return;
      hide(current); current = null; wrap.classList.remove('mm-on');
    }
    function warm() {
      // Load the panels' pictures as soon as the pointer reaches the menu, so they are ready when a panel opens.
      if (wrap.__warm) return; wrap.__warm = true;
      wrap.querySelectorAll('[data-mm-panel] img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
    }
    function later(fn, ms) { clearTimeout(closeT); closeT = setTimeout(fn, ms); }

    wrap.querySelectorAll('.mnav a').forEach(function (a) {
      if (!a.hasAttribute('data-mm')) {
        a.addEventListener('mouseenter', function () { if (current) later(close, 120); });
        return;
      }
      a.addEventListener('mouseenter', function () {
        if (!desk.matches) return;
        clearTimeout(closeT); clearTimeout(openT);
        openT = setTimeout(function () { open(a); }, current ? 80 : 120);
      });
      a.addEventListener('mouseleave', function () { clearTimeout(openT); });
      a.addEventListener('touchstart', function () { a.__touch = true; }, { passive: true });
      a.addEventListener('click', function (e) {
        // On a touch screen the first tap opens the panel and the second follows the link.
        if (desk.matches && a.__touch && current !== a) { e.preventDefault(); open(a); }
        a.__touch = false;
      });
      a.addEventListener('focus', warm);
      a.addEventListener('keydown', function (e) {
        if (!desk.matches) return;
        if (e.key === 'ArrowDown' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault(); open(a);
          var first = panelFor(a) && panelFor(a).querySelector('a'); if (first) first.focus();
        }
      });
    });

    wrap.addEventListener('mouseleave', function () { clearTimeout(openT); if (current) later(close, 200); });
    wrap.addEventListener('mouseenter', function () { clearTimeout(closeT); warm(); });
    if (scrim) {
      scrim.addEventListener('mouseenter', function () { later(close, 120); });
      scrim.addEventListener('click', close);
    }
    wrap.querySelectorAll('[data-mm-panel]').forEach(function (p) {
      p.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    });
    wrap.addEventListener('focusout', function (e) { if (current && !wrap.contains(e.relatedTarget)) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) { var a = current; close(); a.focus(); }
    });
    document.addEventListener('click', function (e) { if (current && !wrap.contains(e.target)) close(); });
    window.addEventListener('resize', function () { if (current) { if (!desk.matches) close(); else sizeScrim(); } });

    // Theme editor: show a panel while its block is selected.
    document.addEventListener('shopify:block:select', function (e) {
      var p = e.target && e.target.closest && e.target.closest('[data-mm-panel]'); if (!p) return;
      var a = wrap.querySelector('[data-mm="' + p.id + '"]'); if (a) open(a);
    });
    document.addEventListener('shopify:block:deselect', close);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
